export const isDev = () => window.location.href.search(/dev.|localhost/) !== -1;
